/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  ColumnsData,
  convertSysqueSizeRangeVMToColumns,
  getSysqueSizeRangeVMByColumnMaxValue,
  getSysqueSizeRangeVMByColumnMinValue,
  SysqueSizeRangeItemsVM,
  SysqueSizeRangeVM,
} from '../../models/sysque-size-range-vm';

@Component({
  selector: 'sysque-datagrid-size-range',
  templateUrl: './sysque-datagrid-size-range.component.html',
  styleUrls: ['./sysque-datagrid-size-range.component.scss'],
  standalone: false
})
export class SysqueDatagridSizeRangeComponent implements OnInit {
  @Input() dataGrid: SysqueSizeRangeVM = new SysqueSizeRangeVM();
  @Output() selectedItems: EventEmitter<SysqueSizeRangeItemsVM[]> = new EventEmitter<SysqueSizeRangeItemsVM[]>();
  @Output() cellValueChanged: EventEmitter<void> = new EventEmitter<void>();
  public columns: ColumnsData[] = [];
  public selectedMinSizeRange: string;
  public sizeMinRanges: string[];
  public selectedMaxSizeRange: string;
  public sizeMaxRanges: string[];

  public minSelectedItems: SysqueSizeRangeItemsVM[] = [];
  public maxSelectedItems: SysqueSizeRangeItemsVM[] = [];

  // selected items in the grid
  public selectedRows: SysqueSizeRangeItemsVM[] = [];
  public selectedRowKeys: number[] = [];
  private get editableColumnsNames(): string[] {
    return [
      'Bend Radius',
      'Lead Length',
      'Take Up',
      'Lead Length',
      'Lead Out Length',
      'Minimum Stub Length',
      'Maximum Tail Length',
      'Deduct',
    ];
  }

  public ngOnInit(): void {
    this.columns = convertSysqueSizeRangeVMToColumns(this.dataGrid.sizeRangeItems);

    // Add allowEditing to specific columns
    this.columns = this.columns.map(column => {
      if (this.editableColumnsNames.includes(column.dataField)) {
        return { ...column, allowEditing: true };
      }
      return { ...column, allowEditing: false };
    });
    this.sizeMinRanges = this.sizeMaxRanges = [
      ...new Set(this.dataGrid.sizeRangeItems.map(row => row[Object.keys(row)[2]]).map(String)),
    ];

    this.selectedRows = this.dataGrid.sizeRangeItems.filter(item => item.isChecked === 1);
    this.selectedRowKeys = this.selectedRows.map(item => item.id);
  }

  public onMinSizeRangeChanged(event: string): void {
    this.selectedMinSizeRange = event;
    this.minSelectedItems = getSysqueSizeRangeVMByColumnMinValue(this.dataGrid.sizeRangeItems, Number(event));

    this.selectedRows =
      this.maxSelectedItems.length === 0
        ? this.minSelectedItems
        : this.maxSelectedItems.filter(item => this.minSelectedItems.some(minItem => minItem.id === item.id));
    this.selectedRowKeys = this.selectedRows.map(item => item.id);
  }

  public onMaxSizeRangeChanged(event: string): void {
    this.selectedMaxSizeRange = event;
    this.maxSelectedItems = getSysqueSizeRangeVMByColumnMaxValue(this.dataGrid.sizeRangeItems, Number(event));

    this.selectedRows =
      this.minSelectedItems.length === 0
        ? this.maxSelectedItems
        : this.minSelectedItems.filter(item => this.maxSelectedItems.some(maxItem => maxItem.id === item.id));
    this.selectedRowKeys = this.selectedRows.map(item => item.id);
  }

  public onSelectionChanged($event: any): void {
    const selectedRows = $event['selectedRowsData'];
    if (selectedRows.length === 0) {
      this.selectedItems.emit([]);
      return;}
      selectedRows.forEach(obj => {
      delete obj['undefined'];
    }) as SysqueSizeRangeItemsVM[];
    selectedRows?.forEach(row => row.isChecked = 1);
    this.selectedItems.emit(selectedRows);
  }

  public onCellPrepared(event: any): void {
    if (event.row === undefined) {
      return;
    }
    event.row.data[event.dataField] = event.displayValue ?? 0;
    this.dataGrid = { ...this.dataGrid, sizeRangeItems: this.dataGrid.sizeRangeItems };
    this.cellValueChanged.emit();
  }
}
